import React from 'react';

export interface IconTabItem {
  id: string;
  icon: any;
  action: () => void;
}

interface IconTabsProps {
  items: IconTabItem[];
  activeIndex: number;
}

export const IconTabs: React.FC<IconTabsProps> = ({ items, activeIndex }) => {
  return (
    <div className="flex flex-row bg-dark-blue w-fit-content rounded-3xl">
      {items?.map((item: IconTabItem, i: number) => (
        <button
          key={`icon-tab-${item.id}`}
          type="button"
          className={`focus:outline-none cursor-pointer rounded-3xl py-1 ${
            activeIndex === i
              ? 'z-10 opacity-100 bg-blue-grey'
              : 'z-0 opacity-50 bg-dark-blue'
          }`}
          onClick={() => item?.action?.()}
        >
          <img
            src={item?.icon}
            className={`w-6 h-6 mx-4 py-0.5 ${
              activeIndex === i ? 'opacity-100' : 'opacity-50'
            }`}
            alt=""
          />
        </button>
      ))}
    </div>
  );
};

